import { atom } from 'jotai';
import { ENUM_SYSTEM_LANGUAGE, atomSystemLanguage } from './atomSystemLanguage';

export const atomRoutePathLangPre = atom((get) => get(atomSystemLanguage) === ENUM_SYSTEM_LANGUAGE.ENGLISH ? 'en' : 'cn');
